"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
const ContentLoader = (props) => {
    /* Refresh mode appears as an absolute div on top of any already existing content, its a smaller spinner. */
    const [refreshMode, setRefreshMode] = react_1.useState(false);
    const { loading, children, data } = props;
    const initialLoadRef = react_1.useRef(false);
    if (loading) {
        initialLoadRef.current = true;
    }
    react_1.useEffect(() => {
        if (!loading && initialLoadRef.current) {
            setRefreshMode(true);
        }
    }, [loading]);
    react_1.useEffect(() => {
        if (!data && refreshMode) {
            setRefreshMode(false);
        }
    }, [refreshMode, data]);
    const spinnerWrapClassName = 'absolute z-10 top-0 left-0 z-10';
    return (react_1.default.createElement("div", { className: classnames_1.default(props.className, 'relative') },
        loading && (react_1.default.createElement("div", { className: classnames_1.default(props.className, spinnerWrapClassName, 'flex w-full h-full pointer-events-none justify-center') },
            react_1.default.createElement(Spinner_1.default, null))),
        children));
};
exports.default = withJourney_1.default('j-content-loader', ContentLoader);
